import { render, staticRenderFns } from "./RevaluationQueue.vue?vue&type=template&id=251a4330&scoped=true"
import script from "./RevaluationQueue.vue?vue&type=script&lang=ts"
export * from "./RevaluationQueue.vue?vue&type=script&lang=ts"
import style0 from "./RevaluationQueue.vue?vue&type=style&index=0&id=251a4330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251a4330",
  null
  
)

export default component.exports